import React, { useRef, useEffect } from 'react';
import '../css/Cursor.css';

const Cursor = () => {
  const cursorRef = useRef(null);

  function isTouchScreen() {
    return 'ontouchstart' in window || navigator.maxTouchPoints > 0;
  }

  const cursorController = isTouchScreen() ? '' : 'custom_cursor';

  useEffect(() => {
    if (isTouchScreen()) return;

    const actualizarPosicionCursor = (event) => {
      const x = event.clientX;
      const y = event.clientY;
      if (!cursorRef.current) return;

      cursorRef.current.style.left = `${x - 16}px`;
      cursorRef.current.style.top = `${y - 16}px`;
      
    };

    document.addEventListener('mousemove', actualizarPosicionCursor);

    return () => {
      document.removeEventListener('mousemove', actualizarPosicionCursor);
    };
  }, []);

  return (
    <div>
      <div className={cursorController} ref={cursorRef}></div>
    </div>
  );
};

export default Cursor;